import { Serializable } from '../../core/models/serializable';
import { MonthlyPlanConfiguration } from './configuration-models/monthly-plan-configuration';

export class ConfigurationData implements Serializable<ConfigurationData> {
  fromObject(obj: any): ConfigurationData {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public workExperienceMaxCategoriesAllowed: number;
  public dateFormat: string;
  public defaultPageSize: number;
  public defaultPagzeSizeOptions: number[];

  public customerContractAttachmentMaxSize: number;

  public industryPickerMaxSelect: number;
  public salesReportMaxDays: number;

  public monthlyPlanParameters: MonthlyPlanConfiguration;

  public currentWebsite: string;

  public smsDefaultLanguageCharsetId: number;

  public mainProviderWebsite: string;

  public primaryLanguage: string;
  public alternativeLanguage: string;

  public locationLevelCount: number;
  public locationFirstLevelId: string;
  public locationRootId: string;
  public jobseekerLocationRequiredLevelCount: number;
  public jobseekerLocationLastHiddenLevelCount: number;
}
